import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    SubmissionText,
    ConfirmationBox,
    SubmissionImage,
} from './submissionComplete.styled';
import SubmittedCheck from 'src/assets/images/SubmittedCheck.svg';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import {
    getOrderSummaryData,
    setOrderSummaryModalState,
    closeOrderSummaryModalState,
} from 'src/pages/orders/redux/actions';
import OrderDetails from 'src/pages/orders/components/orderDetails/OrderDetails';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { setShowNoUsageToReportOrCancelPopup } from '../../redux/action/actionCreators';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { ORDERS, REPORT_USAGE_MAST, REPORT_USAGE_SURGERY } from 'src/constants/appConstants';
import { getConfigurations } from 'src/common/redux/actions';

const SubmitCompletionCard = ({
    isUsagedSubmittedSuccessfully,
    myCaseRefId,
    isReportPayment,
    isNoUsageSubmitPage,
    cancelReason,
    cancelSurgeryData,
    isSubmitClicked,
    setCurrentActivity
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { orderSummaryModal } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const summaryLoading = useSelector(
        (state) => state.orderSummaryReducer.loading
    );
     const isMastOrder = useSelector(
        (state) => state?.reportUsageRootReducer?.usageDetails?.isMastOrder
    );
    const openOrderSummaryHandler = () => {
        dispatch(getConfigurations({resourceType: 'visibility', module: isMastOrder ? REPORT_USAGE_MAST : REPORT_USAGE_SURGERY}, ORDERS));
        dispatch(getOrderSummaryData());
        dispatch(
            setOrderSummaryModalState({
                myCaseRef: myCaseRefId,
                orderSummaryModal: true,
            })
        );
        if (isNoUsageSubmitPage) {
            dispatch(
                setShowNoUsageToReportOrCancelPopup({
                    showNoUsagePopup: false,
                    showCancelPopup: false,
                    surgeryData: cancelSurgeryData,
                    viewProcedureScreen: false,
                    cancelReason,
                    showCaseCancelOrPostpone:false,
                })
            );
        }
    };

    const closeOrderSummaryHandler = () => {
        if (isNoUsageSubmitPage) {
            dispatch(
                setShowNoUsageToReportOrCancelPopup({
                    showNoUsagePopup: false,
                    showCancelPopup: false,
                    surgeryData: cancelSurgeryData,
                    viewProcedureScreen: true,
                    cancelReason,
                    showCaseCancelOrPostpone:false,
                })
            );
        }
        dispatch(
            closeOrderSummaryModalState({
                myCaseRef: '',
                orderSummaryModal: false,
            })
        );
    };
    return (
        <>
            <ConfirmationBox>
                <SubmissionImage
                    src={
                        isUsagedSubmittedSuccessfully
                            ? SubmittedCheck
                            : AlertCircleOutline
                    }
                    isUsagedSubmittedSuccessfully={
                        isUsagedSubmittedSuccessfully
                    }
                />
                <SubmissionText>
                    <span
                        style={{
                            color: '#202124',
                            lineHeight: isReportPayment && '20px',
                            paddingTop: isReportPayment && '5px',
                        }}
                    >
                        {isUsagedSubmittedSuccessfully
                            ? isReportPayment
                                ? t('consignmentBilling.submit.submissionComplete')
                                : isSubmitClicked
                                ? t('consignmentBilling.submit.SubmissionInProcess')
                                : t('consignmentBilling.submit.submissionComplete')
                            : t('consignmentBilling.submit.SubmissionFailed')}
                    </span>
                    <span
                        onClick={()=>!isSubmitClicked && openOrderSummaryHandler()}
                        style={{
                            color: '#1010EB',
                            fontSize: '14px',
                            cursor: 'pointer',
                            paddingTop:
                                window.innerWidth <= sizes.mobileDevice &&
                                isReportPayment
                                    ? '10px'
                                    : '5px',
                        }}
                    >
                        {myCaseRefId}
                    </span>
                </SubmissionText>
            </ConfirmationBox>
            <OrderDetails
                showOrderListDetails={orderSummaryModal}
                orderListDetailsClose={closeOrderSummaryHandler}
                fromCalendar={false}
                fromListScreen={false}
                setCurrentActivity={setCurrentActivity}
            />
            {summaryLoading ? (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner
                        id="reportUsage-submitCompletionCard-backdrop-loadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                    ></Spinner>
                </Backdrop>
            ) : (
                <></>
            )}
        </>
    );
};

export default SubmitCompletionCard;
